import { ActionType, createAction } from 'typesafe-actions';

type ConfirmEditModeDocuments = {
  document: string;
  annotation: string;
};

type ConfirmEditModeFulfilledPayload = {
  results: ConfirmEditModeDocuments[];
};

export const confirmEditModeFulfilled = createAction(
  'CONFIRM_EDITMODE_FULFILLED',
  (payload: ConfirmEditModeFulfilledPayload, _: number) => payload,
  (_: ConfirmEditModeFulfilledPayload, currentAnnotationId: number) => ({
    currentAnnotationId,
  })
)();

export type EditModeActions = ActionType<typeof confirmEditModeFulfilled>;
